module.exports = __webpack_public_path__ + "img/big-belly-bin.cbf33791.jpg";